import { render, staticRenderFns } from "./LabelGIcon.vue?vue&type=template&id=462e34b0&"
import script from "./LabelGIcon.vue?vue&type=script&lang=js&"
export * from "./LabelGIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports